module.exports = __webpack_public_path__ + "img/heart.357c95f7.svg";